export const FORM_NAME = 'Institution-basic-info-form';
